import { Link } from "react-router-dom";
import Breadcrumbs from "../../styles/components/Breadcrumbs";
import "../../styles/pages/content/_administration.scss";

export default function AdministrationComms() {
    return (
        <div className="adm-sub" id="administration-comms">
            <div className="adm-sub__inner">
                <Breadcrumbs
                    items={[
                        { label: "Home", href: "/" },
                        { label: "Administration", href: "/administration" },
                        {
                            label: "Communications",
                            href: "/administration/comms",
                        },
                    ]}
                />

                <div className="adm-sub__header">
                    <div>
                        <p className="adm-sub__eyebrow">Administration</p>
                        <h1 className="adm-sub__title">Communications</h1>
                        <p className="adm-sub__sub">
                            Send targeted updates and lifecycle messages to Mooz
                            users.
                        </p>
                    </div>
                </div>

                <section className="adm-sub__panel">
                    <h2>Overview</h2>
                    <p>
                        Coordinate outreach campaigns, announcements, and
                        re-engagement flows.
                    </p>
                </section>
            </div>
        </div>
    );
}
